import React from 'react'
import { useTranslation } from 'hooks/useTranslation'
import {
  HowItWorksRoot,
  HeaderBox,
  Header,
  HowItWorksBox,
  TextColumn,
  PointsList,
  PointsListItem,
  CheckIcon,
  ImageColumn,
  ImageWrapper,
} from './HowItWorks.styles'
import Image, { StaticImageData } from 'next/image'
import { Text } from 'components/Text'
import Trans from 'next-translate/Trans'

type HowItWorksProps = {
  image: StaticImageData
}

export const HowItWorks = ({ image }: HowItWorksProps) => {
  const { t } = useTranslation()

  return (
    <HowItWorksRoot>
      <HeaderBox>
        <Header>{t('recipes-overview:how-it-works.freeze-dried.title')}</Header>
      </HeaderBox>
      <HowItWorksBox>
        <ImageColumn>
          <ImageWrapper className="how-does-fd-work-image-container">
            <Image
              layout="fill"
              objectFit="cover"
              src={image}
              alt={t('recipes-overview:how-it-works.freeze-dried.image-alt')}
            />
          </ImageWrapper>
        </ImageColumn>
        <TextColumn>
          <PointsList>
            <PointsListItem>
              <CheckIcon name="check" />
              <Text size="body">
                <Trans
                  i18nKey={t(`recipes-overview:how-it-works.freeze-dried.points.1`)}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Text>
            </PointsListItem>
            <PointsListItem>
              <CheckIcon name="check" />
              <Text size="body">
                <Trans
                  i18nKey={t(`recipes-overview:how-it-works.freeze-dried.points.2`)}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Text>
            </PointsListItem>
            <PointsListItem>
              <CheckIcon name="check" />
              <Text size="body">
                <Trans
                  i18nKey={t(`recipes-overview:how-it-works.freeze-dried.points.3`)}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Text>
            </PointsListItem>
          </PointsList>
        </TextColumn>
      </HowItWorksBox>
    </HowItWorksRoot>
  )
}

HowItWorks.displayName = 'HowItWorks'
